<template>
    <card v-if="conversionArray.length !== 0 ">
      <table class="table">
        <thead>
          <th>Acción de conversión</th>
          <th>Todas las conversiones</th>
        </thead>

        <tbody>
          <tr v-for="(conversionAction, index) in conversionArray" :key="index">
            <td>{{ translateAction(conversionAction.conversionAction.toLowerCase()) }}</td>
            <td>{{ Number(conversionAction.allConversion).toLocaleString() }}</td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <th>Total</th>
            <th>{{ calculateTotalConversion(conversionArray).toLocaleString() }}</th>
          </tr>
        </thead>
      </table>
    </card>
</template>
<script>

import getConversionRelation from "../services/conversion_actions.js"

export default {
  name: "conversion-table",
  props: {
    conversionArray: Array,
  },
  data() {
    return{
      category: "Acciones",
      relationsObject: {},
      conversionActionRows: [
        {
          allConversion: 0,
          conversionAction: ""
        }
      ],
      totalConversions: 0
    }
  },
  async created() {
    const relations = await getConversionRelation();
    this.conversionArray = this.orderConversionArray(this.conversionArray)
    this.relationsObject = relations;
  },
  methods: {
    translateAction: function(action = ""){
      return this.relationsObject[action] ? this.relationsObject[action] : action;
    },
    calculateTotalConversion: function(conversionRows){
      return conversionRows.reduce((acc,cur) => Number(acc) + Number(cur.allConversion),0);
    },
    orderConversionArray: function(array = []){
      return array.sort((a,b)=> b.allConversion - a.allConversion)
    }
  }

}
</script>
<style lang="scss" scoped>
  .widget {
    &.keyword-widget,
    &.campaign-widget {
      grid-column: 1 / -1;
    }
  }
  .widget-title{
      margin-bottom: 16px;
      font-weight: 600;
      font-size: 16px;
    }
  .responsive-table{
    overflow-x: scroll;
  }
</style>